// props
export const defaultProps = {
  value: "",
  ckConfig: {}, // ck 配置
  extentsConfig: [], // 扩展配置
  viewAttr: 2, // 编辑权限
  readOnly: false, // 是否自读
  className: "",
  style: {},
  readOnlyInSourceMode: false, // 源码模式是否只读
  ls: false, // 模块需要的特殊处理
  bottomBarConfig: [], // 底部工具栏
  bottomBarRight: {}, // 底部右侧按钮
  bootomBarStyle: {}, // 底部右侧按钮样式
  getDataWidthDefaultFont: true, // 获取值的时候，是否拼接上有默认字体和默认字体大小的div
  dropToUploadImg: true,
  dropToUploadFile: false,
  dropUploadImgUrl: "/api/doc/upload/uploadFile", // 拖拽上传附件地址,默认和通用上传地址一致（流程需要区分）
  dropUploadFileUrl: "/api/doc/upload/uploadFile", // 拖拽上传附件地址,默认和通用上传地址一致（流程需要区分）
  dropUploadImgParams: {},
  dropUploadFileParams: {}
};

// state
export const defaultState = {
  loading: false, // load ck loading
  status: false,
  mode: "wysiwyg", // wysiwyg:正常编辑模式, source:markdown源码模式
  maximize: false, // 最大化
  nomalHeight: 0, // 富文本高度
  modalTrans: "inhreit",
  loadExtends: false, // 是否开始加载扩展属性
  required: false // 是否显示必填
};

// ckConfig
export const defultCkConfig = {
  renderAsCk: true,
  toolbarStartupExpanded: true,
  toolbarCanCollapse: false,
  allowedContent: true,
  // startupFocus: true, // 默认输入框获得焦点
  tabSpaces: 4,
  pasteFilter: null, // 复制其他地方的内容不过滤
  enterMode: 1,
  contentsCss:
    window.ecologyContentPath ||
    "" + "/cloudstore/resource/pc/ckeditor-4.6.2/weaver/contents.css", // 默认解析css
  fontSize_sizes:
    "8/8px;9/9px;10/10px;11/11px;12/12px;14/14px;16/16px;18/18px;20/20px;22/22px;24/24px;26/26px;28/28px;36/36px;48/48px;72/72px",
  font_en:
    "Arial/Arial; Comic Sans MS/Comic Sans MS; Courier New/Courier New; Georgia/Georgia; Lucida Sans Unicode/Lucida Sans Unicode; Tahoma/Tahoma; Times New Roman/Times New Roman; Trebuchet MS/Trebuchet MS; Verdana/Verdana;",
  font_zh:
    "宋体/SimSun;新宋体/NSimSun;仿宋/FangSong;楷体/KaiTi;仿宋_GB2312/FangSong_GB2312;方正小标宋简体/FZXiaoBiaoSong-B05S;楷体_GB2312/KaiTi_GB2312;黑体/SimHei;华文细黑/STXihei;华文楷体/STKaiti;华文宋体/STSong;华文中宋/STZhongsong;华文仿宋/STFangsong;华文彩云/STCaiyun;华文琥珀/STHupo;华文隶书/STLiti;华文行楷/STXingkai;华文新魏/STXinwei;方正舒体/FZShuTi;方正姚体/FZYaoti;细明体/MingLiU;新细明体/PMingLiU;微软雅黑/Microsoft YaHei;微软正黑/Microsoft JhengHei;",
  uploadUrl: "/api/doc/upload/uploadFile" // 通用上传地址（工具栏上传）
};

// atwho config
export const defaultAtwhoConfig = {
  at: "@",
  tpl: "<li data-uid='${id}' data-value='@${name}'>${name}</li>",
  insert_tpl:
    "<a href='/hrm/HrmTab.jsp?_fromURL=HrmResource&id=${id}' atsome='@${id}' atsome-uid='${id}' atsome-name='${name}' atsome-py='${py}' contenteditable='false' style='cursor:pointer;text-decoration:none !important;margin-right:8px;color:#2777c1!important;' target='_blank' onclick='if(window.openLink){window.openLink.openHrm(${id});return false;}'>${atwho-data-value}</a>&nbsp;",
  show_the_at: true,
  start_with_space: false,
  with_repeat_matcher: false,
  search_key_py: "py",
  pageIndex: 1,
  pageSize: 20,
  apiRequest: true
};



// WEBPACK FOOTER //
// ./ecology9/wea-rich-text/propType.js